<template>
  <div class="flex flex-col gap-4">
    <div>
      <BaseInput
        ref="searchInput"
        v-model="searchTerm"
        type="search"
        :placeholder="t('blocksSettings.image.search_placeholder')"
        @keydown.enter.prevent="searchPhotos">
        <template #prefix>
          <SearchIcon :size="16" class="search stroke-secondary-600" />
        </template>
        <template #suffix>
          <ArrowLeft
            :size="16"
            class="stroke-secondary-600"
            @click="searchPhotos"/>
        </template>
      </BaseInput>
    </div>
    <div v-if="isLoading" class="flex items-center justify-center py-8">
      <LoadingOverlay
        :height="20"
        :active="isLoading"
        :opacity="0.9"
        :can-cancel="false"
        :is-full-page="false"
        class="absolute inset-0"/>
    </div>
    <div v-else-if="photos && photos.length > 0" class="flex py-2">
      <div class="columns-3 gap-4 space-y-4">
        <div
          v-for="photo in photos"
          :key="photo.id"
          class="cursor-pointer"
          @click="setImage(photo)">
          <img class="rounded" :src="photo.urls.small" alt="Unsplash Photo" />
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col items-center justify-center py-8">
      <span class="text-secondary-800 font-simplerBold">אין תוצאות</span>
      <EmptyState />
    </div>
    <PVDivider />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { createApi } from 'unsplash-js';
import LoadingOverlay from 'vue-loading-overlay';
import { BaseInput } from '@nwire/amit-design-system';
import { useI18n } from 'vue-i18n';
import { Search as SearchIcon, ArrowLeft } from 'lucide-vue-next';
import EmptyState from '../../../assets/empty-state.svg?component';
import PVDivider from 'primevue/divider';

const { t } = useI18n();

const photos = ref();
const searchTerm = ref();
const isLoading = ref(false);
const searchInput = ref();
const unsplash = createApi({
  accessKey: '0HAU2LH1rJVLGArxuiw7Ic2lpY2aVqCcmd3rxXNDvkA',
});

const imageSrc = defineModel<string>('src', { required: true });
const imageAlt = defineModel<string>('alt', { required: false });

const setImage = image => {
  imageSrc.value = image.urls.regular;
  imageAlt.value = image.alt_description;
};

const searchPhotos = () => {
  isLoading.value = true;
  searchInput.value?.$el.querySelector('input').blur();
  unsplash.search
    .getPhotos({ page: 1, query: searchTerm.value || 'inspire' })
    .then(result => {
      if (result.errors) {
        console.log('error occurred: ', result.errors[0]);
      } else {
        photos.value = result.response.results;
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  searchPhotos();
});
</script>
